import React from 'react';
import SliderBoundlessPcMobile from 'components/SliderBoundlessPcMobile';
import PageNavControls from 'components/PageNavControls';
import { IProps, IState } from './types';
import commonService from 'utils/commonService';
import { Article } from 'bff/models/new/article';
import newListService from 'bff/services/newListService';
// import moment from 'moment';
import moment from 'moment-timezone';
import { RouterSettings } from 'constants/models/routerSettings';
import _ from 'lodash';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';

class NewsAnnouncement extends React.Component<IProps, IState> {
  componentDidMount () {
    // 頁面初始取得傳入的公司公告內容
    if (!storageService.getItem(storageKeys.NewsDetail)) {
      this.props.history.goBack();
      return;
    }

    const announcementInfo = JSON.parse(storageService.getItem(storageKeys.NewsDetail)) as Article;

    this.setState({ announcementInfo: announcementInfo });
  }

  componentDidUpdate () {
    // 內容資料有更動，移至畫面上方
    commonService.scrollToTop();
  }

  componentWillUnmount () {
    // 頁面關閉，暫存明細資料
    storageService.removeItem(storageKeys.NewsDetail);
    storageService.setItem(storageKeys.NewsDetail, JSON.stringify(this.state.announcementInfo));
  }

  render () {
    /**
   * @description 點選上下一則的事件
  */
    const handleNextPrevClick = async (sn: number) => {
      if (!sn) return;
      const announcementInfo = await newListService.fetchArticle(sn);
      if (!announcementInfo) return;

      storageService.removeItem(storageKeys.NewsDetail);
      storageService.setItem(storageKeys.NewsDetail, JSON.stringify(announcementInfo));
      this.setState({ announcementInfo: announcementInfo });
    };

    const handleImgListContent = () => {
      return this.state.announcementInfo && this.state.announcementInfo.IMAGE_URL.length > 1 ? (
        <SliderBoundlessPcMobile loopSetting={this.state.announcementInfo?.IMAGE_URL.length === 3} name="news-announcement-gallery-slider">
          {_.map(this.state.announcementInfo?.IMAGE_URL, (url: string, index: number) => (
            <SliderBoundlessPcMobile.Item key={index}>
              <img src={url} alt="" />
            </SliderBoundlessPcMobile.Item>
          ))}
        </SliderBoundlessPcMobile>
      ) : (
        _.map(this.state.announcementInfo?.IMAGE_URL, (url: string, index: number) => (
          <div className="news-announcement__gallery-img-container" key={index}>
            <img key={index} src={url} alt="" />
          </div>
        ))
      );
    };

    return this.state && this.state.announcementInfo && (
      <div className="news-announcement">
        <div className="template-container">
          <div className="template-content">
            <div className="news-announcement__header">
              <div className="news-announcement__period">
                <span>更新日期： {moment(this.state.announcementInfo.CREATE_TIME).format('YYYY/MM/DD')}</span>
              </div>
              <div className="news-announcement__title">{this.state.announcementInfo.TITLE}</div>
            </div>
          </div>
        </div>
        <div className="news-announcement__gallery">
          {handleImgListContent()}
          {/* <SliderBoundlessPcMobile name="news-announcement-gallery-slider">
        <SliderBoundlessPcMobile.Item>
          <a href="/">
            <img src="https://sites.google.com/site/2017onepieceofcake/_/rsrc/1484057610111/3/1.jpg" alt="" />
          </a>
        </SliderBoundlessPcMobile.Item>

        <SliderBoundlessPcMobile.Item>
          <a href="/">
            <img src="https://sites.google.com/site/2017onepieceofcake/_/rsrc/1484057610111/3/1.jpg" alt="" />
          </a>
        </SliderBoundlessPcMobile.Item>

        <SliderBoundlessPcMobile.Item>
          <a href="/">
            <img src="https://wptavern.com/wp-content/uploads/2020/05/google-logo.jpg" alt="" />
          </a>
        </SliderBoundlessPcMobile.Item>
      </SliderBoundlessPcMobile> */}
        </div>
        <div className="template-container">
          <div className="template-content">
            <div className="news-announcement__content">
              <p>{commonService.htmlParser(this.state.announcementInfo.CONTENT)}</p>
            </div>
          </div>
        </div>
        {/* 頁面導航控制項 */}
        <PageNavControls
          prevBtnLink="/"
          onPrevClick={() => handleNextPrevClick(this.state.announcementInfo?.PREV_SN || 0)}
          nextBtnLink="/"
          onNextClick={() => handleNextPrevClick(this.state.announcementInfo?.NEXT_SN || 0)}
          navBtnLink={RouterSettings.News.List}
          navBtnText="回最新消息頁"
          prevSN={this.state.announcementInfo.PREV_SN}
          nextSN={this.state.announcementInfo.NEXT_SN}
        />
      </div>
    );
  }
};

export default NewsAnnouncement;
